import { render } from "./RandselDialog.vue?vue&type=template&id=32a1f6fc&scoped=true&ts=true"
import script from "./RandselDialog.vue?vue&type=script&lang=ts"
export * from "./RandselDialog.vue?vue&type=script&lang=ts"

import "./RandselDialog.vue?vue&type=style&index=0&id=32a1f6fc&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a1f6fc"]])

export default __exports__